import { FormattedMessage } from 'react-intl';
import {
  useAddAutoReplyMutation,
  useFetchTemplateQuery,
  useUpdateAutoReplyMutation,
} from '../../api/autoReplyAPI';
import { BackButton, ButtonsContainer, Container, SaveButton } from './styles';
import AutoReplyFormRenderContent from '../../components/OutOfOfficeFormRenderContent';
import Error from '../../components/Error';

const AutoReplyForm = ({ inputValues, requiredFields, setInputValues, setShowAutoReplyPopup }) => {
  const { data: templateAutoReply, error: errorTemplate } = useFetchTemplateQuery(true);
  const [addAutoReply] = useAddAutoReplyMutation();
  const [updateAutoReply] = useUpdateAutoReplyMutation();

  const handleCancelPopup = () => {
    setInputValues({});
    setShowAutoReplyPopup(false);
  };
  const handleAutoReplyFormSubmit = async (e) => {
    e.preventDefault();
    
    const formValues = { ...inputValues };
    
    if (Array.isArray(formValues.autoReplyTextSequence)) {
      formValues.autoReplyTextSequence = formValues.autoReplyTextSequence.filter(
        item => item.autoReplyTextSequenceText && item.autoReplyTextSequenceText.trim() !== ''
      );
    }
    
    formValues.platforms = formValues?.platforms?.map((option) => option?.value ?? option);
    if ('isEditable' in formValues) {
      const id = formValues?._id?.$oid;
      delete formValues._id;
      delete formValues.ownerId;
      delete formValues.status;
      delete formValues.createdAt;
      delete formValues.updatedAt;
      delete formValues.isEditable;
      await updateAutoReply({
        id: id,
        ...formValues,
      });
    } else {
      await addAutoReply({ autoReply: { ...formValues } });
    }
    setShowAutoReplyPopup(false);
  };

  return (
    <Container>
      {(errorTemplate && 'error' in errorTemplate && <Error message={errorTemplate.error} />) || (
        <form autoComplete="off" onSubmit={handleAutoReplyFormSubmit}>
          <AutoReplyFormRenderContent
            inputValues={inputValues}
            requiredFields={requiredFields}
            setInputValues={setInputValues}
            autoReplyFormData={templateAutoReply?.data}
          />
          <ButtonsContainer>
            <BackButton variant="outlined" onClick={handleCancelPopup}>
              <FormattedMessage id="auto-reply.popup.button.cancel" />
            </BackButton>
            <SaveButton variant="contained" onClick={handleAutoReplyFormSubmit}>
              <FormattedMessage id="auto-reply.popup.button.save" />
            </SaveButton>
          </ButtonsContainer>
        </form>
      )}
    </Container>
  );
};

export default AutoReplyForm;
